import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { config } from '../../utils/config';

import NProgress from '../NProgress';
import PublicRoute from './PublicRoute';

// Pages
const RevendicaPremiu = lazy(() => import('../../containers/RevendicaPremiu'));
const PageRouter = lazy(() => import('../../containers/PageRouter'));
const Teasing = lazy(() => import('../../containers/Teasing'));
const ListaCastigatiri = lazy(() => import('../../containers/ListaCastigatiri'));
const RevendicaInvitatia = lazy(() => import('../../containers/RevendicaInvitatia'));
const HartaLocatiilor = lazy(() => import('../../containers/HartaLocatiilor'));
// Misc pages
const NotFound = lazy(() => import('../../containers/NotFound'));

const Router = () => {
    return (
        <Suspense fallback={<NProgress />}>
            <Routes>
                <Route
                    path={config.path.index}
                    element={
                        <PublicRoute>
                            <PageRouter />
                        </PublicRoute>
                    }
                />
                <Route
                    path={config.path.listaLocatiilor}
                    element={
                        <PublicRoute>
                            <HartaLocatiilor />
                        </PublicRoute>
                    }
                />
                <Route
                    path={config.path.teasing}
                    element={
                        <PublicRoute>
                            <Teasing />
                        </PublicRoute>
                    }
                />
                <Route
                    path={config.path.listaCastigatori}
                    element={
                        <PublicRoute>
                            <ListaCastigatiri />
                        </PublicRoute>
                    }
                />
                //revendica premiu din sms
                <Route
                    path={config.path.revendicaPremiu}
                    element={
                        <PublicRoute>
                            <RevendicaPremiu />
                        </PublicRoute>
                    }
                />
                <Route path={config.path.error} element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};

export default Router;
